import React from 'react';

export const IconDeveloper = () => (
    <svg width='24' height='24' xmlns='http://www.w3.org/2000/svg'>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10 5h4v7h-4V5zM5 9.34A8.96 8.96 0 003 15v2h18v-2c0-2.14-.75-4.11-2-5.66V12h-1V8.3a9 9 0 00-3-1.79V13H9V6.51A9 9 0 006 8.3V12H5V9.34zM22 18H2v2h20v-2z'
            fill='currentColor'
        />
    </svg>
);
